import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import Card from '../components/Card'
import List, { ListItem } from '../components/List'
import PageHeading from '../components/PageHeading'

interface LabelTraceStatusData {
  pending: number
  processed: number
}

interface LabelTraceStatusProps {
  status: LabelTraceStatusData
}

export default class LabelTraceStatus
  extends Component<LabelTraceStatusProps> {
  get status (): ListItem[] {
    const { pending, processed } = this.props.status
    return [
      { key: 'Pending', value: String(pending) },
      { key: 'Processed', value: String(processed) }
    ]
  }

  render () {
    return (
      <Card>
        <PageHeading text={i18n("Status")} />
        <List items={this.status} />
      </Card>
    )
  }
}
